import React, { useEffect } from "react";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import NoData from "../../../../widget/common/ui/NoData";
import { ConversationMessagesList } from "../../widget/chat_conversation/ConversationMessages";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import { DepartmentChatsContextImport } from "../../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import ChatsDefaultMessage from "../../widget/chats/ChatsDefaultMessage";
import { socket } from "../../../../service/socket/SocketService";

const DepartmentChatConversations = () => {
  const { chatSelected, userId, socketStatus } = ChatsContextImport();

  const {
    conversationDetail,
    conversationMessages,
    getSelectedChatSession,
    disconnectCallBacks,
    resetMessages,
    conversationCallBack,

    handlePressStart,
    handleClickMessage,
    handlePressEnd,
    selectedMesasgeIds,
    longPressStatus,
  } = DepartmentChatsContextImport();

  useEffect(() => {
    if (socketStatus) {
      getSelectedChatSession();
    }
    // eslint-disable-next-line
  }, [socketStatus]);

  useEffect(() => {
    resetMessages();

    socket.onAny(conversationCallBack);

    return () => {
      disconnectCallBacks();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {chatSelected != null && (
        <>
          {conversationDetail != null &&
            conversationDetail?.default_message_status === "1" &&
            UtilityHelper.isNotEmpty(conversationDetail?.default_message!) && (
              <ChatsDefaultMessage
                message={conversationDetail?.default_message!}
              />
            )}

          {conversationMessages == null ? (
            <Center>{Loader.normal()}</Center>
          ) : Object.keys(conversationMessages).length === 0 ? (
            <NoData />
          ) : (
            <>
              <ConversationMessagesList
                flag={chatSelected?.flag!}
                userId={userId}
                messages={conversationMessages}
                handleClickMessage={handleClickMessage}
                handlePressStart={handlePressStart}
                handlePressEnd={handlePressEnd}
                selectedMesasgeIds={selectedMesasgeIds}
                longPressStatus={longPressStatus}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default DepartmentChatConversations;
